import { ConfigContext } from "../config_context";
import {useContext} from "react";
import {Button} from "./button.tsx";

export default function ModalConfirmButton(props:{onClick: () => void}) {
  const modal_confirm_button_label = useContext(ConfigContext).modal_confirm_button_label;

  return (<Button label={modal_confirm_button_label} onClick={props.onClick}/>);
}
